import {useShallow} from 'zustand/react/shallow'
import {useConfirmationDialogStore} from './confirmationDialogStore'
import {Flexbox} from '../flexbox/FlexBox'
import {StyledConfirmationDialogRadioGroup, StyledConfirmationDialogRadioItem} from './style'
import {useTranslation} from '@/translations/i18n'

export const ConfirmationDialogActions = ({
    onChangeType,
    showConversation,
    showNotification
}: {
    onChangeType: () => void
    showConversation: boolean
    showNotification: boolean
}) => {
    const {t} = useTranslation()
    const {accordionType, setAccordionType, setIsAccordionOpen} = useConfirmationDialogStore(
        useShallow(state => ({
            accordionType: state.accordionType,
            setAccordionType: state.setAccordionType,
            setIsAccordionOpen: state.setIsAccordionOpen
        }))
    )

    const handleAccordionTypeChange = (type: 'no-action' | 'notification' | 'conversation') => {
        if (type) {
            setAccordionType(type)
            onChangeType()
            setIsAccordionOpen(true)
        }
    }

    return (
        <Flexbox gap={5} fullWidth>
            <StyledConfirmationDialogRadioGroup
                type="single"
                value={accordionType}
                onValueChange={handleAccordionTypeChange}
            >
                <Flexbox fullWidth>
                    <StyledConfirmationDialogRadioItem value="no-action" $isSelected={accordionType == 'no-action'}>
                        {t('confirmation_dialog:no_action')}
                    </StyledConfirmationDialogRadioItem>
                    {showNotification && (
                        <StyledConfirmationDialogRadioItem
                            value="notification"
                            $isSelected={accordionType == 'notification'}
                        >
                            {t('confirmation_dialog:notification')}
                        </StyledConfirmationDialogRadioItem>
                    )}
                    {showConversation && (
                        <StyledConfirmationDialogRadioItem
                            value="conversation"
                            $isSelected={accordionType == 'conversation'}
                        >
                            {t('confirmation_dialog:conversation')}
                        </StyledConfirmationDialogRadioItem>
                    )}
                </Flexbox>
            </StyledConfirmationDialogRadioGroup>
        </Flexbox>
    )
}
